module.exports = {"id":"177922","name":"Kamil Grosicki","rating":"74","photo":"./data/images/photos/0/177922.png","club":{"name":"Hull City","logo":"./data/images/clubs/HullCity.png"},"positions":["MG","MD","AG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KamilGrosicki0.json
// module id = 2283
// module chunks = 0